import React from "react";
import {
  FaExpand,
  FaProjectDiagram,
  FaShieldAlt,
  FaNetworkWired,
} from "react-icons/fa";

function Scalability() {
  return (
    <>
      <div
        className="feature-style-one-area default-padding bg-gray blurry-shape-right-bottom"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/3.png)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Features</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Benefits of Cosmos SDK with Xeer Technology
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="fade-up-anim">
            <div className="row">
              <div className="col-xl-12">
                <div className="feature-style-one-items">
                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaExpand size={40} />
                      </div>
                      <h4>Scalability</h4>
                      <p>
                        Cosmos SDK is designed for highly scalable applications,
                        supporting business expansion.
                      </p>
                    </div>
                  </div>

                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaProjectDiagram size={40} />
                      </div>
                      <h4>Interoperability</h4>
                      <p>
                        The IBC protocol allows easy integration with other
                        blockchains in the Cosmos network.
                      </p>
                    </div>
                  </div>

                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaShieldAlt size={40} />
                      </div>
                      <h4>Security</h4>
                      <p>
                        With built-in security protocols and Xeer’s experienced
                        developers, we ensure robust data protection.
                      </p>
                    </div>
                  </div>

                  <div className="feature-style-one">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaNetworkWired size={40} />
                      </div>
                      <h4>Decentralization</h4>
                      <p>
                        Cosmos SDK supports distributed ledgers, promoting
                        decentralized governance for your project.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Scalability;
